// Tokyo prefectures and areas data
// Currently only supporting Tokyo prefecture

export interface LocationData {
  prefecture: string;
  prefectureEn: string;
  cities: CityData[];
}

export interface CityData {
  name: string;
  nameEn: string;
  wards: WardData[];
}

export interface WardData {
  name: string;
  nameEn: string;
}

// Tokyo 23 special wards
export const TOKYO_WARDS: WardData[] = [
  { name: "千代田区", nameEn: "Chiyoda" },
  { name: "中央区", nameEn: "Chuo" },
  { name: "港区", nameEn: "Minato" },
  { name: "新宿区", nameEn: "Shinjuku" },
  { name: "文京区", nameEn: "Bunkyo" },
  { name: "台東区", nameEn: "Taito" },
  { name: "墨田区", nameEn: "Sumida" },
  { name: "江東区", nameEn: "Koto" },
  { name: "品川区", nameEn: "Shinagawa" },
  { name: "目黒区", nameEn: "Meguro" },
  { name: "大田区", nameEn: "Ota" },
  { name: "世田谷区", nameEn: "Setagaya" },
  { name: "渋谷区", nameEn: "Shibuya" },
  { name: "中野区", nameEn: "Nakano" },
  { name: "杉並区", nameEn: "Suginami" },
  { name: "豊島区", nameEn: "Toshima" },
  { name: "北区", nameEn: "Kita" },
  { name: "荒川区", nameEn: "Arakawa" },
  { name: "板橋区", nameEn: "Itabashi" },
  { name: "練馬区", nameEn: "Nerima" },
  { name: "足立区", nameEn: "Adachi" },
  { name: "葛飾区", nameEn: "Katsushika" },
  { name: "江戸川区", nameEn: "Edogawa" },
];

// Popular areas within Tokyo (subset for quick selection)
export const TOKYO_POPULAR_AREAS = [
  "Shibuya",
  "Shinjuku",
  "Minato",
  "Meguro",
  "Setagaya",
  "Nakano",
];

export const TOKYO_CITY: CityData = {
  name: "東京",
  nameEn: "Tokyo",
  wards: TOKYO_WARDS,
};

export const TOKYO_PREFECTURE: LocationData = {
  prefecture: "東京都",
  prefectureEn: "Tokyo",
  cities: [TOKYO_CITY],
};

// All available prefectures (currently only Tokyo)
export const PREFECTURES: LocationData[] = [TOKYO_PREFECTURE];

// Occupancy options
export const OCCUPANT_OPTIONS = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5+" },
];
